import { render } from "./CorN.vue?vue&type=template&id=75c1e582"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CorN.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75c1e582"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75c1e582', __exports__)) {
    api.reload('75c1e582', __exports__)
  }
  
  module.hot.accept("./CorN.vue?vue&type=template&id=75c1e582", () => {
    api.rerender('75c1e582', render)
  })

}


export default __exports__